import DescriptionAccordion from './DescriptionAccordion';

export default DescriptionAccordion;
